import { render, staticRenderFns } from "./DoctorCardA.vue?vue&type=template&id=1583653f&scoped=true"
import script from "./DoctorCardA.vue?vue&type=script&lang=js"
export * from "./DoctorCardA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1583653f",
  null
  
)

export default component.exports